/**
 * Loads an external script when its placeholder nears the viewport, instead of
 * at parse time (build log row 115). The placeholder is
 * <div data-lazy-script="https://…/loader.js?id"></div>; the script takes its
 * place, so a loader that inserts its widget where its own tag sits (Trustindex)
 * renders in the same spot as before. Without IntersectionObserver the script
 * loads at once.
 */
(() => {
  if (window.__bettinoLazyScript) return;
  window.__bettinoLazyScript = true;

  const MARGIN = '600px 0px';

  /** @param {HTMLElement} host */
  const load = (host) => {
    const src = host.dataset.lazyScript;
    if (!src) return;

    const script = document.createElement('script');
    script.async = true;
    script.src = src;
    host.replaceWith(script);
  };

  const hosts = document.querySelectorAll('[data-lazy-script]');

  if (!('IntersectionObserver' in window)) {
    hosts.forEach(load);
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        observer.unobserve(entry.target);
        load(/** @type {HTMLElement} */ (entry.target));
      }
    },
    { rootMargin: MARGIN }
  );

  hosts.forEach((host) => observer.observe(host));
})();
